import { emailDomainRegex } from "pages/mlops/ducks/utils";
import * as yup from "yup";

export const raiseEnquiryValidationSchema = yup
.object({
    name: yup.string().required().label("Name").max(100),
    email: yup.string().required("Email is required").email().matches(emailDomainRegex, "Invalid email domain. Please enter a toyota email id.").label("Email").max(250),
    topic: yup.string().required().label("Topic").max(250),
    message: yup.string().required().label("Message").max(600)
});
